export enum ImageCTAVariantsMap {
  "option-1" = "basic",
  "option-2" = "ahPlus",
}
